import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';

import commonProps from './common/common-props';
import ProfileComment from '../../comments/profile-comment';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;

  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};

  article {
    padding: 16px 16px 0 16px !important;
    margin: 0 0 16px 0 !important;
  }
`;

export default function MyComments({ comments }) {
  const common = commonProps();

  return (
    <ThemeProvider theme={common}>
      <Container>
        {comments.map(comment => (<ProfileComment key={`comment-${comment.id}`} comment={comment} />))}
      </Container>
    </ThemeProvider>
  );
}

MyComments.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.string,
    publishedAt: PropTypes.string,
    id: PropTypes.number,
    wire: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
    }).isRequired,
    userId: PropTypes.number,
  })).isRequired,
};
